import MdButon from './mdButton'
import MdCard from './mdCard'
import MdFormGroupInput from './mdFormGroupInput'
import MdTab from './mdTab'
import MdStatsWidget from './mdStatsWidget'
import MdTable from './mdTable'
import MdBlockquote from './mdBlockquote'
import MdChartWidget from './mdChartWidget'

import EdForm from './edForm'
import EdButon from './edButton'
import EdInput from './edInput'
import EdInputTooltip from './edInputTooltip'
import EdSelect from './edSelect'
import EdSelectOptions from './edSelect/selectOptions'
import EdDatepicker from './edDatepicker'
import EdCheckbox from './edCheckbox'
import EdRadio from './edRadio'
import EdTextarea from './edTextarea'
import EdUpload from './edUpload'
import EdMetaNav from './edMetaNav'
import EdPrimaryNav from './edPrimaryNav'
import EdTitleNav from './edTitleNav'
import EdTabNav from './edTabNav'
import EdTab from './edTabNav/edTab'
import EdModal from './edModal'
import EdCard from './edCard'
import EdPanel from './edPanel'
import EdSection from './edSection'
import EdBox from './edBox'
import EdSwitch from './edSwitch'
import EdFieldGroup from './edFieldGroup'
import EdSlider from './edSlider'

export default {
  install(Vue) {
    Vue.component(MdButon.name, MdButon)
    Vue.component(MdCard.name, MdCard)
    Vue.component(MdFormGroupInput.name, MdFormGroupInput)
    Vue.component(MdTab.name, MdTab)
    Vue.component(MdStatsWidget.name, MdStatsWidget)
    Vue.component(MdTable.name, MdTable)
    Vue.component(MdBlockquote.name, MdBlockquote)
    Vue.component(MdChartWidget.name, MdChartWidget)

    Vue.component(EdForm.name, EdForm)
    Vue.component(EdButon.name, EdButon)
    Vue.component(EdInput.name, EdInput)
    Vue.component(EdInputTooltip.name, EdInputTooltip)
    Vue.component(EdSelect.name, EdSelect)
    Vue.component(EdSelectOptions.name, EdSelectOptions)
    Vue.component(EdDatepicker.name, EdDatepicker)
    Vue.component(EdCheckbox.name, EdCheckbox)
    Vue.component(EdRadio.name, EdRadio)
    Vue.component(EdTextarea.name, EdTextarea)
    Vue.component(EdUpload.name, EdUpload)
    Vue.component(EdMetaNav.name, EdMetaNav)
    Vue.component(EdPrimaryNav.name, EdPrimaryNav)
    Vue.component(EdTitleNav.name, EdTitleNav)
    Vue.component(EdTabNav.name, EdTabNav)
    Vue.component(EdTab.name, EdTab)
    Vue.component(EdModal.name, EdModal)
    Vue.component(EdCard.name, EdCard)
    Vue.component(EdPanel.name, EdPanel)
    Vue.component(EdSection.name, EdSection)
    Vue.component(EdBox.name, EdBox)
    Vue.component(EdSwitch.name, EdSwitch)
    Vue.component(EdFieldGroup.name, EdFieldGroup)
    Vue.component(EdSlider.name, EdSlider)
  }
}



// WEBPACK FOOTER //
// ./src/core/components/index.js